<template>
  <div id="administrative">
    <BannerSwiper msg="科室导览"></BannerSwiper>

    <div id="administrativeBody">
      <div>
        <breadcrumb msg="科室导览"></breadcrumb>
      </div>
      <h2 style="font-size:30px;font-family: dasongbiao;color: rgb(69, 109, 171);font-size:30px">科室导航</h2>
      <div id="administrativeType" v-for="item in divisionList" :key="item.id">
        <div id="name">
          <img style="width:15px" src="../assets/img/arr2.png" alt />
          <span>{{item.name}}</span>
        </div>
        <div id="A">
          <div id="body" v-for="items in item.children" :key="items.id">
            <span @click="open(items.id)">{{items.name}}</span>
          </div>
        </div>
        <div id="line1"></div>
        <div id="line" v-if="item.id < total"></div>
      </div>
    </div>
  </div>
</template>
<script>
import BannerSwiper from "../components/bannerSwiper";

import breadcrumb from "../components/breadcrumb";
export default {
  components: { breadcrumb, BannerSwiper },
  data() {
    return {
      divisionList: JSON.parse(sessionStorage.getItem('divisionList')),
      total: 3,
      list: []
    };
  },
  methods: {
    open(id) {
      this.$router.push({ path: "/administrativeDetail?id=" + id });
    }
  }
};
</script>
<style lang="less">
#administrative {
  /deep/ #address {
    color: rgb(69,109,171) ;
  }
  /deep/ .el-breadcrumb__inner a,
  .el-breadcrumb__inner.is-link {
    color: rgb(69,109,171)  !important;
  }
  /deep/ .el-breadcrumb__item:last-child .el-breadcrumb__inner,
  .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
  .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
  .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
    color: rgb(69,109,171)  !important;
    font-weight: 600 !important;
  }
  /deep/ .el-breadcrumb__separator {
    color: rgb(69,109,171)  !important;
  }
}
</style>
<style lang="less" scoped>
#administrativeBody {
  width: 1200px;
  margin: 0 auto;
  padding: 40px 0;
}
#administrative {
  background-image: url(../assets/img/jkjt3.jpg);
}
h2 {
  font-size: 40px;
  text-align: center;
  color: #595959;
}
#administrativeType {
  margin-bottom: 30px;
  #name {
    font-size: 22px;
    span {
      margin-left: 10px;
    }
  }
  #line {
    margin-top: 20px;
    height: 25px;
    clear: both;
    background-image: url(../assets/img/bar15.png);
    background-size: 100% 100%;
  }
  #line1 {
    clear: both;
  }
  #A {
    padding: 15px;
    #body {
      word-break: break-all;
      span:hover{
        background-image: url(../assets/img/pubc-tabs-icon4.png);
        background-size: 100% 100%;
        cursor: pointer;
      }
      span {
        padding: 10px 30px;
        text-align: center;
        min-width: 140px;
        margin: 20px 15px;
        display: block;
        float: left;
        border: 1px solid #005b49;
        color: #ffffff;
        background-image: url(../assets/img/btn2_a.png);
        background-size: 100% 100%;
      }
    }
  }
}
</style>
